module.exports = __webpack_public_path__ + "img/-e-unit_zsxys@2x.6c66d51b.png";